<template>
  <div class="w-24 h-full relative flex pl-4">
    <div class="flex justify-center items-center w-full">
      <div :class="[styleType, 'bsload bsload1']"></div>
      <div :class="[styleType, 'bsload bsload2']"></div>
      <div :class="[styleType, 'bsload bsload3']"></div>
    </div>
  </div>
</template>

<script lang="ts">
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class LoadingControl extends Vue {
  @Prop({ type: String, default: '' }) styleType: String;
}
</script>
<style scoped>
@keyframes bsload-animate {
  50% {
    background-color: var(--motif-500);
    transform: scale(0.8);
  }
}

@keyframes zhongqiu-bsload-animate {
  50% {
    background-color: #fff095;
    transform: scale(0.8);
  }
}

@keyframes yuandan-bsload-animate {
  50% {
    background-color: #fc866f;
    transform: scale(0.8);
  }
}

.bsload {
  width: 10px;
  height: 10px;
  margin-right: 10px;
  background-color: #ebebff;
  border-radius: 50%;
  animation: bsload-animate 1s infinite;
}

.zhongqiu-bsload {
  animation: zhongqiu-bsload-animate 1s infinite;
}

.yuandan-bsload {
  animation: yuandan-bsload-animate 1s infinite;
}

.bsload.bsload2 {
  animation-delay: 0.2s;
}
.bsload.bsload3 {
  animation-delay: 0.4s;
}
</style>
